export class OrderStatus {
    status?:string;
    orderDetailReference?:string;
}
